import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';

const NotFoundPage: React.FC = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-9xl font-bold text-primary-500">404</h1>
      <h2 className="text-2xl font-heading font-semibold text-neutral-800 mt-4">Page non trouvée</h2>
      <p className="text-neutral-600 mt-2 mb-8">Désolé, la page que vous recherchez n'existe pas.</p>
      <div className="flex justify-center gap-4">
        <Link to="/" className="btn btn-primary"><Home className="w-4 h-4 mr-2" />Accueil</Link>
        <Link to="/apartments" className="btn btn-outline"><Search className="w-4 h-4 mr-2" />Appartements</Link>
      </div>
    </div>
  </div>
);
export default NotFoundPage;
